import React from 'react';
import Create from './pages/Create';
import Edit from './pages/Edit';
import Index from './pages/Index';
import { AppRouteProps } from '~/routes';

export default function DeviceRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/device', component: Index, isProtected: true, permissions: ['device_index']},
    {path: '/device/create', component: Create, isProtected: true, permissions: ['device_create']},
    {path: '/device/edit/:id', component: Edit, isProtected: true, permissions: ['device_edit']},
  ];

  return routes;
}
